import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Wrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  height: 50px;
  @media (max-width: 830px), (max-height: 530px) {
    height: 30px;
  }
`;
export const TitleWrapper = styled.div`
  padding: 15px;
  flex: 0 0 auto;
`;
export const Title = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
`;
export const Storage = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  font-size: 10px;
  font-weight: 100;
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  padding: 15px;
`;
export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
`;
export const TrashButton = styled(Button)`
  width: 120px;
  font-size: 14px;
  margin-right: 30px;
  color: ${ColorSF2.navyBlue};
`;
export const ButtonImage = styled.img`
  width: 25px;
  height: 25px;
`;
export const LinkButtonImage = styled.img`
  width: 20px;
  height: 20px;
`;
export const PrivateButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const OperatorName = styled.div`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
